import { ellipsis } from '@synoptic/ui-kit/utility.css.ts';
import { clsx } from 'clsx';
import { Ref } from 'react';
import { NavLink, NavLinkProps } from '@/routes-utils/navigation.tsx';
import { menuItemText, subMenuItemLink } from './menu-action.css.ts';

export type MenuSubActionLinkProps = {
  label: string;
  external?: boolean;
  ref?: Ref<HTMLAnchorElement>;
} & NavLinkProps;

export const MenuSubActionLink = function MenuSubActionLink({
  ref,
  label,
  to,
  external,
  className,
  ...props
}: MenuSubActionLinkProps) {
  return (
    <NavLink
      ref={ref}
      to={to}
      target={external ? '_blank' : ''}
      className={clsx(subMenuItemLink, className)}
      prefetch="render"
      {...props}
    >
      <span className={clsx(menuItemText, ellipsis)}>{label}</span>
    </NavLink>
  );
};
